import nxtStylesEn from '@nxtpeople/nxt-styles/dist/translations/en.json';
import nxtStylesFr from '@nxtpeople/nxt-styles/dist/translations/fr.json';
import nxtStylesNl from '@nxtpeople/nxt-styles/dist/translations/nl.json';
import { createI18n } from 'vue-i18n';
import en from './core/locales/en.json';
import fr from './core/locales/fr.json';
import nl from './core/locales/nl.json';

const userAgentLocale = window.navigator.language.substring(0, 2);
const savedLocale = window.localStorage.getItem('locale');
const locale = savedLocale || userAgentLocale || 'nl';

const i18n = createI18n({
   legacy: false,
   locale,
   fallbackLocale: 'nl',
   messages: { nl: { ...nl, ...nxtStylesNl }, en: { ...en, ...nxtStylesEn }, fr: { ...fr, ...nxtStylesFr } },
   globalInjection: true,
});

export default i18n;

